import { useIsWarnBeforeWebViewReloadEnabled } from '@/app-shell/flags/desktop-flags';
import { tauriWindowController } from '@/tauri/controller/window';
import { isTauri } from '@/tauri/utils';
import { useEffect } from 'react';

/**
 * Headless desktop-only mount component. Syncs the feature flag
 * controlling the native Webview reload guard to Rust.
 *
 * Mounted at the app root so the Rust `on_navigation` hook has the correct
 * state before the user attempts any native context menu reloads.
 */
export const DesktopNavigationGuardMount = () => {
  const isWarnBeforeReloadEnabled = useIsWarnBeforeWebViewReloadEnabled();

  useEffect(() => {
    if (!isTauri()) {
      return;
    }
    void tauriWindowController.set_navigation_guard_enabled(isWarnBeforeReloadEnabled);
  }, [isWarnBeforeReloadEnabled]);

  return null;
};
